import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { SiteRoot } from './SiteRoot';

const isAdmin = window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/');
const rootElement = document.getElementById('root')!;

if (isAdmin) {
  const { AdminApp } = await import('./admin/AdminApp');
  rootElement.replaceChildren();
  createRoot(rootElement).render(
    <StrictMode>
      <AdminApp />
    </StrictMode>,
  );
} else {
  const site = <SiteRoot path={window.location.pathname} />;
  if (rootElement.hasChildNodes()) hydrateRoot(rootElement, site);
  else createRoot(rootElement).render(site);
}
